<mat-sidenav-container class="sidenav-container" (backdropClick)="close('backdrop')">
  <mat-sidenav class="sidenav" #sidenav [mode]="'side'" (keydown.escape)="close('escape')" disableClose>
    <div class="div-brand" *ngIf="opcionesMenu.vertical && opcionesMenu.vertical.length > 0">
      <button mat-icon-button (click)="close('toggle button'); sideActive = true;">
        <mat-icon class="mat-icons-menu">menu</mat-icon>
      </button>
      <img src="../../../../../assets/images/logo_rnt.png" width="50" height="auto" class="d-inline-block align-top navbar-brand-sidenav"
        alt="">
    </div>
    <hr>
    <div>
      <!-- <mat-tree [dataSource]="nestedDataSource" [treeControl]="nestedTreeControl" class="tree-sidenav">
          <mat-tree-node *matTreeNodeDef="let node" matTreeNodeToggle>
            <li class="mat-tree-node side-menu">
              <a class="pl-3" routerLinkActive="active" [routerLink]="[node.ruta_url]">
                {{node.filename}}
              </a>
            </li>
          </mat-tree-node>

          <mat-nested-tree-node *matTreeNodeDef="let node; when: hasNestedChild">
              <div class="mat-tree-node side-menu">
                <a class="pl-3" matTreeNodeToggle  routerLinkActive="active" [attr.aria-label]="'toggle ' + node.filename">
                    {{node.filename}}
                </a>
              </div>
              <ul [class.tree-sidenav-invisible]="!nestedTreeControl.isExpanded(node)">
                <ng-container matTreeNodeOutlet></ng-container>
              </ul>
          </mat-nested-tree-node>
        </mat-tree> -->


      <mat-tree [dataSource]="nestedDataSource" [treeControl]="nestedTreeControl" class="tree-sidenav">
        <mat-tree-node *matTreeNodeDef="let node" matTreeNodeToggle>
          <mat-selection-list class="mat-tree-node" dense>
            <mat-list-option class="pl-2 check" routerLinkActive="active_2" [routerLink]="[node.ruta_url]">
              {{node.filename}}
            </mat-list-option>
          </mat-selection-list>
        </mat-tree-node>

        <mat-nested-tree-node *matTreeNodeDef="let node; when: hasNestedChild">
          <div class="mat-tree-node">
            <button mat-icon-button matTreeNodeToggle [attr.aria-label]="'toggle ' + node.filename">
              <mat-icon class="mat-icon-rtl-mirror">
                {{nestedTreeControl.isExpanded(node) ? 'expand_more' : 'chevron_right'}}
              </mat-icon>
            </button>
            {{node.filename}}
          </div>
          <ul [class.tree-sidenav-invisible]="!nestedTreeControl.isExpanded(node)">
            <ng-container matTreeNodeOutlet></ng-container>
          </ul>
        </mat-nested-tree-node>
      </mat-tree>
    </div>
  </mat-sidenav>

  <mat-sidenav-content>
    <nav class="navbar navbar-light bg-white shadow-sm">
      <button *ngIf="sideActive && opcionesMenu.vertical && opcionesMenu.vertical.length > 0" mat-icon-button (click)="sidenav.open(); sideActive = false;"
        class="button-menu">
        <mat-icon class="mat-icons-menu">menu</mat-icon>
      </button>
      <label *ngIf="sideActive" class="navbar-brand ml-2">
        <img src="../../../../../assets/images/logo_rnt.png" class="d-inline-block align-top img-responsive" height="32"
          alt="">
        Registro Nacional de Turismo
      </label>
      <div class="navbar-expand">
        <ul class="navbar-nav m-auto">
          <li class="nav-item" *ngFor="let item of menuHorizontal">
            <a class="nav-item nav-link ml-3" routerLinkActive="active" [routerLink]="[item.ruta_url]">
              <span>
                {{item.descripcion}}
              </span>
              <mat-icon class="material-icons align-bottom" *ngIf="item?.descripcion === 'Correo'">email</mat-icon>
            </a>
          </li>
        </ul>
      </div>
      <div class="navbar-expand m-auto"></div>
      <a class="nav-item nav-link btn btn-back m-3 pl-4 pr-4" *ngIf="!userLogin" [routerLink]="['/establecimientos']">
        <span class="pl-4 pr-4">Regresar</span>
      </a>
      <div class="navbar-expand" *ngIf="userLogin">
        <div class="navbar-nav">
          <a class="mr-4 nav-item nav-link d-flex align-items-center" 
              [routerLink]="['/notificaciones']" routerLinkActive="active"
              *ngIf="esUsuarioPrestador">
            <span class="mr-2">Comunicaciones</span>
            <mat-icon class="notification-icon" [matBadgeHidden]="notificationsCount <= 0" 
              [matBadge]="notificationsCount" matBadgeColor="warn" matBadgeSize="small">
                notifications
              </mat-icon>
          </a>
          <a class="nav-item nav-link" [routerLink]="['/perfil']" routerLinkActive="active">
            <span class="h6 mr-2">Mi perfil</span>
            <img src="../../../../../assets/icons/perfil.png" class="d-inline-block img-responsive" alt="">
          </a>
          <a class="nav-item nav-link">
            <span class="h6 mt-1">{{user_name}}</span>
          </a>
          <a class="nav-item nav-link" (click)="onClose()">
            <img src="../../../../../assets/icons/logout.png" class="d-inline-block img-responsive pointer" alt="">
          </a>
        </div>
      </div>
    </nav>
    <ng-content></ng-content>
    <nav class="navbar navbar-light bg-white shadow-sm footer border-top bottom-0 w-100">
      <address class="h6 m-0 p-0 ml-2 mr-2 small">
        <a class="text-muted ol pointer" (click)="onOLClick()" style="cursor: pointer;">&copy; Confec&aacute;maras</a>
         | Red de c&aacute;maras de comercio - {{year|date:'y'}}
      </address>
      <div class="navbar-expand m-auto"></div>
      <div class="navbar-expand mr-5">
        <div class="navbar-nav">
          <a class="nav-item nav-link" [routerLink]="['/contactenos']">
            <span>Contáctenos</span>
          </a>
          <a class="nav-item nav-link" [routerLink]="['/faq']">
            <span>Ayuda</span>
          </a>
          <a class="nav-item nav-link" [routerLink]="['/terminos']">
            <span>Términos</span>
          </a>
        </div>
      </div>
    </nav>
  </mat-sidenav-content>
</mat-sidenav-container>
